import React from 'react';
import Icon from '../../../components/AppIcon';

const HowItWorksSection = () => {
  const steps = [
    {
      number: '01',
      icon: 'Sun',
      title: 'Overdag opslaan',
      description: 'Je zonnepanelen wekken stroom op. Wat je niet direct gebruikt, slaat de batterij automatisch op.',
      color: 'bg-amber-50 border-amber-200',
      iconColor: 'text-amber-600',
      iconBg: 'bg-amber-100',
    },
    {
      number: '02',
      icon: 'Moon',
      title: "'s Avonds je eigen stroom gebruiken",
      description: "Als de zon onder is, levert de batterij jouw opgeslagen stroom. Geen inkoop van het net nodig.",
      color: 'bg-blue-50 border-blue-200',
      iconColor: 'text-blue-600',
      iconBg: 'bg-blue-100',
    },
    {
      number: '03',
      icon: 'Cpu',
      title: 'Automatisch gestuurd door EMS',
      description: 'Het energiemanagementsysteem regelt alles slim op de achtergrond. Jij merkt er niets van.',
      color: 'bg-primary/5 border-primary/20',
      iconColor: 'text-primary',
      iconBg: 'bg-primary/10',
    },
  ];

  return (
    <section id="zo-werkt-het" className="py-16 lg:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="inline-flex items-center space-x-2 text-primary bg-primary/10 px-3 py-1.5 rounded-full text-xs font-heading font-semibold uppercase tracking-wider mb-4">
            <Icon name="Lightbulb" size={12} />
            <span>Zo simpel werkt het</span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-heading font-bold text-foreground leading-tight">
            Je batterij regelt het, jij merkt er niets van
          </h2>
          <p className="mt-4 text-lg font-body text-muted-foreground">
            In drie stappen van zonnestroom naar eigen gebruik — zonder technische kennis.
          </p>
        </div>

        {/* Steps — asymmetric bento layout */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {steps?.map((step, i) => (
            <div
              key={step?.number}
              className={`relative rounded-2xl border p-7 ${step?.color} ${i === 2 ? 'md:col-span-1' : ''}`}
            >
              {/* Step number */}
              <span className="absolute top-5 right-6 text-5xl font-heading font-black text-black/5 select-none">
                {step?.number}
              </span>

              <div className={`w-12 h-12 ${step?.iconBg} rounded-xl flex items-center justify-center mb-5`}>
                <Icon name={step?.icon} size={22} className={step?.iconColor} />
              </div>

              <h3 className="text-lg font-heading font-bold text-foreground mb-2">{step?.title}</h3>
              <p className="text-sm font-body text-muted-foreground leading-relaxed">{step?.description}</p>

              {/* Connector arrow (not on last) */}
              {i < 2 && (
                <div className="hidden md:flex absolute -right-4 top-1/2 -translate-y-1/2 z-10 w-8 h-8 bg-white border border-border rounded-full items-center justify-center shadow-elevation-1">
                  <Icon name="ChevronRight" size={14} className="text-muted-foreground" />
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Energy flow visual */}
        <div className="mt-10 bg-white border border-border rounded-2xl p-6 shadow-elevation-1">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-0">
            {[
              { icon: 'Sun', label: 'Zonnepanelen', color: 'text-amber-500' },
              { icon: 'ArrowRight', label: '', color: 'text-muted-foreground', small: true },
              { icon: 'Battery', label: 'GRP Batterij', color: 'text-primary' },
              { icon: 'ArrowRight', label: '', color: 'text-muted-foreground', small: true },
              { icon: 'Home', label: 'Jouw woning', color: 'text-blue-500' },
              { icon: 'ArrowRight', label: '', color: 'text-muted-foreground', small: true },
              { icon: 'Monitor', label: 'EMS Portaal', color: 'text-purple-500' },
            ]?.map((item, i) => (
              <div key={i} className={`flex flex-col items-center ${item?.small ? 'opacity-40' : ''}`}>
                <div className={`w-10 h-10 ${item?.small ? '' : 'bg-gray-50 border border-border rounded-xl'} flex items-center justify-center`}>
                  <Icon name={item?.icon} size={item?.small ? 16 : 20} className={item?.color} />
                </div>
                {item?.label && <p className="text-xs font-caption text-muted-foreground mt-1.5">{item?.label}</p>}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
